import { useCallback, useRef } from 'react';

export const useDebounce = (callback: (...args: any[]) => void, delay: number) => {
    const timeoutRef = useRef<NodeJS.Timeout>();

    const debouncedCallback = useCallback(
        (...args: any[]) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                callback(...args);
            }, delay);
        },
        [callback, delay]
    );

    return debouncedCallback;
};

export const useDebounceWithIdle = (callback: (...args: any[]) => void, idleTime: number = 500) => {
    const timeoutRef = useRef<NodeJS.Timeout>();
    const lastInputRef = useRef<number>();

    const debouncedCallback = useCallback(
        (...args: any[]) => {
            const now = Date.now();
            lastInputRef.current = now;

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                // Only execute if this was the last input received
                if (lastInputRef.current === now) {
                    callback(...args);
                }
            }, idleTime);
        },
        [callback, idleTime]
    );

    return debouncedCallback;
}; 